var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 150,
    viewBox: "0 0 187 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "#E6FFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6723_41081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 34H176C177.326 34 178.598 34.5268 179.536 35.4645C180.473 36.4021 181 37.6739 181 39V64C181 65.3261 180.473 66.5979 179.536 67.5355C178.598 68.4732 177.326 69 176 69H41C39.6739 69 38.4021 68.4732 37.4645 67.5355C36.5268 66.5979 36 65.3261 36 64V39C36 37.6739 36.5268 36.4021 37.4645 35.4645C38.4021 34.5268 39.6739 34 41 34V34Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 42H79C77.3431 42 76 43.3431 76 45C76 46.6569 77.3431 48 79 48H105C106.657 48 108 46.6569 108 45C108 43.3431 106.657 42 105 42Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123 55H79C77.3431 55 76 56.3431 76 58C76 59.6569 77.3431 61 79 61H123C124.657 61 126 59.6569 126 58C126 56.3431 124.657 55 123 55Z",
    fill: "#DEE9FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51.5C68 43.4919 61.5081 37 53.5 37C45.4919 37 39 43.4919 39 51.5C39 59.5081 45.4919 66 53.5 66C61.5081 66 68 59.5081 68 51.5Z",
    fill: "#1485FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5997 56.194C53.8411 56.1938 55.0467 55.7785 56.0247 55.014L59.0997 58.089L60.0887 57.1L57.0127 54.024C57.7855 53.0248 58.1972 51.7933 58.1805 50.5303C58.1638 49.2672 57.7199 48.047 56.9209 47.0685C56.122 46.0901 55.0152 45.4111 53.781 45.1422C52.5468 44.8732 51.2579 45.0303 50.1243 45.5877C48.9908 46.1451 48.0794 47.07 47.5388 48.2116C46.9982 49.3533 46.8602 50.6444 47.1473 51.8745C47.4344 53.1046 48.1297 54.2013 49.1198 54.9857C50.1099 55.7701 51.3365 56.196 52.5997 56.194ZM52.5997 46.4C53.4304 46.4 54.2424 46.6463 54.9331 47.1078C55.6238 47.5693 56.1621 48.2253 56.48 48.9927C56.7979 49.7602 56.8811 50.6047 56.719 51.4194C56.557 52.2341 56.1569 52.9825 55.5696 53.5699C54.9822 54.1572 54.2338 54.5572 53.4191 54.7193C52.6044 54.8814 51.7599 54.7982 50.9924 54.4803C50.225 54.1624 49.569 53.6241 49.1075 52.9334C48.646 52.2427 48.3997 51.4307 48.3997 50.6C48.3997 49.4861 48.8422 48.4178 49.6299 47.6302C50.4175 46.8425 51.4858 46.4 52.5997 46.4Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6723_41081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 79H26C23.2386 79 21 81.2386 21 84V109C21 111.761 23.2386 114 26 114H161C163.761 114 166 111.761 166 109V84C166 81.2386 163.761 79 161 79Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90 87H64C62.3431 87 61 88.3431 61 90C61 91.6569 62.3431 93 64 93H90C91.6569 93 93 91.6569 93 90C93 88.3431 91.6569 87 90 87Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108 100H64C62.3431 100 61 101.343 61 103C61 104.657 62.3431 106 64 106H108C109.657 106 111 104.657 111 103C111 101.343 109.657 100 108 100Z",
    fill: "#DEE9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96.5C53 88.4919 46.5081 82 38.5 82C30.4919 82 24 88.4919 24 96.5C24 104.508 30.4919 111 38.5 111C46.5081 111 53 104.508 53 96.5Z",
    fill: "#1485FD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5997 101.194C38.8411 101.194 40.0467 100.778 41.0247 100.014L44.0997 103.089L45.0887 102.1L42.0127 99.024C42.7855 98.0248 43.1972 96.7933 43.1805 95.5303C43.1638 94.2672 42.7199 93.047 41.9209 92.0685C41.122 91.0901 40.0152 90.4111 38.781 90.1422C37.5468 89.8732 36.2579 90.0303 35.1243 90.5877C33.9908 91.1451 33.0794 92.07 32.5388 93.2116C31.9982 94.3533 31.8602 95.6444 32.1473 96.8745C32.4344 98.1046 33.1297 99.2013 34.1198 99.9857C35.1099 100.77 36.3365 101.196 37.5997 101.194ZM37.5997 91.4C38.4304 91.4 39.2424 91.6463 39.9331 92.1078C40.6238 92.5693 41.1621 93.2253 41.48 93.9927C41.7979 94.7602 41.8811 95.6047 41.719 96.4194C41.557 97.2341 41.1569 97.9825 40.5696 98.5699C39.9822 99.1572 39.2338 99.5572 38.4191 99.7193C37.6044 99.8814 36.7599 99.7982 35.9924 99.4803C35.225 99.1624 34.569 98.6241 34.1075 97.9334C33.646 97.2427 33.3997 96.4307 33.3997 95.6C33.3997 94.4861 33.8422 93.4178 34.6299 92.6302C35.4175 91.8425 36.4858 91.4 37.5997 91.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6723_41081",
    x: 30,
    y: 31,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6723_41081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6723_41081",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6723_41081",
    x: 15,
    y: 76,
    width: 157,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6723_41081"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6723_41081",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.b21c846d7f82895a80135f13f1d964a8.svg";
export { ForwardRef as ReactComponent };